import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ToastClientService } from "../../../services/toast/toast-client.service";

@Component({
  selector: 'app-chanel',
  templateUrl: './chanel.component.html',
  styleUrls: ['./chanel.component.scss']
})
export class ChanelComponent implements OnInit {
  addOrEditChannel: string;
  channels = [];
  classifications = [];
  title = 'modal2';
  formGroup;
  deletePopupUiData;
  hideHasParent: boolean = true;
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public toast: ToastClientService

  ) {}

  ngOnInit() {
    this.getAllChannels();
  }

  getAllChannels() {
    this.apiService.getHeaders(this.apiConfig.configGetChannel)
      .subscribe((res: any) => {
    console.log(res);
        // this.channels = res.data.channel;
        this.channels = res.body.data.all_channels;
        this.classifications = res.body.data.channel_classification;
        // console.log(this.channels);
      }, err => {
        console.log(err);
      })
  }

  addChannel(targetModal) {
    this.addOrEditChannel = 'add'

    this.formGroup = this.fb.group({
      channel_code:  new FormControl('', [Validators.required, Validators.pattern('^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$')]),
      channel_desc:  new FormControl('', [Validators.required, Validators.pattern('^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$')]),
      parent_channel_id: 0,
      hierarchy_level: 0,
      program_id: 1,
      channel_classification_id: 0
    });

    this.showChannelModal(targetModal);
  }

  get f() {
    return this.formGroup.controls;
  }

  editChannel(targetModal, channelInfo){
    this.addOrEditChannel = 'edit'
    this.formGroup = this.fb.group({
      id: channelInfo.id,
      channel_code: new FormControl(channelInfo.channel_code, [Validators.required, Validators.pattern('^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$')]),
      channel_desc: new FormControl(channelInfo.channel_desc, [Validators.required, Validators.pattern('^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$')]),
      parent_channel_id: channelInfo.parent_channel_id,
      hierarchy_level: 0,
      program_id: 1,
      channel_classification_id: channelInfo.channel_classification_id
    });

    this.showChannelModal(targetModal);
  }

  deleteChannel(targetModal, channelInfo){
    this.addOrEditChannel = 'delete'
    this.deletePopupUiData = channelInfo.channel_code;

    this.formGroup = this.fb.group({
      channel_id: channelInfo.id,
      program_id: 1
    });

    this.showChannelModal(targetModal);
  }

  showChannelModal(targetModal){
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static'
    });
  }

  submitted = false;

  onSubmitChannel(formData) {

    this.submitted = true;

    if(this.formGroup.invalid){
      return
    }

    let apiUrl;
    if(this.addOrEditChannel == 'add'){
      apiUrl = this.apiConfig.configAddChannel
    } else if(this.addOrEditChannel == 'edit'){
      apiUrl = this.apiConfig.configEditChannel
    } else if(this.addOrEditChannel == 'delete'){
      apiUrl = this.apiConfig.configDeleteChannel
    }

    // console.log('API:', apiUrl, 'FD:', formData);

      this.apiService.post(apiUrl, formData)
      .subscribe((res:any)=>{
        this.channelActionSuccess(formData);
        this.toast.Success(res.data.message);
      },err=>{
        console.log('err', err);
      })

  }

  channelActionSuccess(data){
    this.modalService.dismissAll();
    this.getAllChannels();
  }
}
